import React, { useEffect } from "react";
import { Table } from "antd";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import AwardForm from "./AwardForm"; 
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import {
  getAwardList,
  doAwardDelete,
  doAwardReset,
} from "../../../../redux/award/awardState";

const AwardTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {

  const columns = [
    {
      title: "Award Title",
      dataIndex: "awd_title",
      key: "awd_title",
      width: "25%",
      render: (awd_title) => <span>{awd_title}</span>,
    },
    {
      title: "Description",
      dataIndex: "awd_description",
      key: "awd_description",
      width: "60%",
      render: (awd_description) => <span>{awd_description}</span>,
    },
    {
      title: (
        <PopupButton id="add_award" title="Add Award" label="Add" btnClass="btn-small">
          <AwardForm recordId="0" mode="edit" />
        </PopupButton>
      ),
      dataIndex: "awd_id",
      key: "awd_id",
      width: "15%",
      render: (_, record) => (
        <CrudOption
          baseRoute="/console/awards"
          recordId={record?.awd_id}
          deleteHandler={doDelete}
          allowEdit={true}
          allowView={false}
          editMode="modal"
          modalWidth={900}
          title="Edit Award"
          closeHandler={doRecordReset}
          editHandler={(recordId, doRecordReset ) => (
            <AwardForm recordId={recordId} mode="edit" onCancel={doRecordReset} />
          )}
        />
      ),
    },
  ];

	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  return (
    <Card extra={"w-full h-full p-4"}>
      <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
        <Table
          dataSource={recordList}
          columns={columns}
          rowKey={(record) => record.awd_id}
		      pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}   
          onChange={handleTableChange(doSearch, filters)}
        />
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.award.awardList?.items,
	pagination: state.award.awardList?.pagination,
	filters: state.award.arwardList?.filters,
	requesting: state.award.awardList?.requesting,
	error: state.award.awardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getAwardList(filters)),
  doDelete: (id) => dispatch(doAwardDelete(id)),
  doRecordReset: () => dispatch(doAwardReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardTable);
